import { render, staticRenderFns } from "./student-voucher.vue?vue&type=template&id=5db72454&scoped=true"
import script from "./student-voucher.vue?vue&type=script&lang=js"
export * from "./student-voucher.vue?vue&type=script&lang=js"
import style0 from "./student-voucher.vue?vue&type=style&index=0&id=5db72454&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db72454",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db72454')) {
      api.createRecord('5db72454', component.options)
    } else {
      api.reload('5db72454', component.options)
    }
    module.hot.accept("./student-voucher.vue?vue&type=template&id=5db72454&scoped=true", function () {
      api.rerender('5db72454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/student-voucher.vue"
export default component.exports